<!--
  FrameX scope totals: read-only per-scope type/qty sums, pinned under the
  Frames list when grouped by Scope. Aggregation is `scopeTotals` (markers.js).
-->
<script>
  import { scopeTotals } from "../markers.js";
  import { plural } from "../labels.js";

  export let group;
  /** The same working-set frames FrameMarkersList renders (unsorted/ungrouped is fine — scopeTotals re-groups by scope). */
  export let frames;

  $: qtyOf = (loc) => $group.items[loc.record_id]?.quantity ?? 0;
  $: totals = scopeTotals(frames, {
    scopeOf: (loc) => $group.items[loc.record_id]?.scope,
    qtyOf,
  });

  // scopeTotals only returns per-scope sums, which can hide a zero-qty frame
  // sitting inside an otherwise-nonzero group — so the "at 0" count is taken
  // from the raw frame list, not from a group total being zero.
  $: zeroQtyCount = (frames || []).filter((loc) => qtyOf(loc) === 0).length;
</script>

<div class="fx-scope-totals">
  {#each totals.groups as g (g.scope)}
    <div class="fx-scope-totals-row">
      <span class="fx-scope-totals-label">{g.scope || "Unassigned"}</span>
      <span class="fx-scope-totals-value">
        {g.types} type{plural(g.types)} · {g.qty} qty
      </span>
    </div>
  {/each}
  <div class="fx-scope-totals-row fx-scope-totals-total">
    <span class="fx-scope-totals-label">Total</span>
    <span class="fx-scope-totals-value">
      {totals.total.types} type{plural(totals.total.types)} · {totals.total.qty} qty
    </span>
  </div>
  {#if zeroQtyCount}
    <div class="fx-scope-totals-note">
      {zeroQtyCount} at 0
    </div>
  {/if}
</div>

<style lang="scss">
  .fx-scope-totals {
    flex: none;
    padding: 8px 16px;
    border-top: 1px solid var(--fx-border-light, #eceef1);
    // A faint wash sets the pinned totals apart from the scrolling list above.
    background: #fbfcfd;
  }

  .fx-scope-totals-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
    padding: 2px 0;
    font-size: 12px;
  }

  .fx-scope-totals-label {
    color: var(--fx-text-alt, #374151);
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .fx-scope-totals-value {
    flex: none;
    color: var(--fx-text-secondary, #6b7280);
  }

  .fx-scope-totals-total {
    border-top: 1px solid var(--fx-border-light, #eceef1);
    margin-top: 4px;
    padding-top: 5px;

    .fx-scope-totals-label,
    .fx-scope-totals-value {
      color: var(--fx-text, #1a1d21);
      font-weight: 700;
    }
  }

  .fx-scope-totals-note {
    margin-top: 6px;
    background: var(--fx-amber-bg, #fef3c7);
    border: 1px solid var(--fx-amber-border, #f3d98b);
    color: var(--fx-amber-text, #92400e);
    font-size: 11px;
    font-weight: 600;
    padding: 5px 7px;
    border-radius: 6px;
  }
</style>
